export default {
    login: {
      logIn: '登录',
      username: '账号',
      password: '密码',
      code: '验证码',
      rememberMe: '记住密码',
      personal:"个人中心",
      logout:"退出登录",
      loging:"登录",
      nickname: "昵称",
      name: "姓名",
      email: "邮箱",
      phone: "电话",
      country: "国家",
      company: "公司",
      signin:"登录",
      usernamoremail:'用户名/邮箱',
      verificationCode:"验证码",
      register:"注册",
      remember:"记住密码",
      pleasecontact:"请联系我们获取下载链接",
      firstname:"姓",
      lastname:"名",
      placeholder:"请输入邮箱作为用户名",
      retyoepassword:"请再次输入密码",
      street:"街道地址",
      city:"城市名称",
      registersuccess:"注册成功",
      registertips:"注册已成功，请耐心等待，我们将在24小时内完成审核.",
      usernametips:"请输入您的用户名或邮箱地址",
      passwordtips:"请输入您的密码",
      retyoepasswordtips:"请再次输入密码",
      codetips:"请输入验证码",
      firstnamtips:" 请输入您的名字",
      lastnametips:"请输入您的姓氏",
      companytips:"请输入您的公司名称",
      emailtips:"请输入您的邮箱地址",
      phonetips:"请输入您的电话号码",
      streettips:"请输入您的街道地址",
      citytips:"请输入您的城市",
      emailreg:"请填写正确的电子邮箱地址",
      phonereg:"请填写正确的电话号码",
      passwordreg:"请填写正确的密码",
      loginsuccess:"登录成功",
      message1:"该用户已被禁用。请联系管理员",
      message2:"用户名或密码错误",
      message3:"验证码错误",
      message4:"验证码无效",
      message5:"用户已被禁用。请联系管理员",
      message6:"邮箱包含2至40个字符",
      message7:"验证码错误",
      message8:"失败。登录账号已存在",
      message9:"失败。手机号码已存在",
      message10:"失败，邮箱账号已存在",
      message11:"验证码无效",
      qrcode:"联系页面",
      forgotPassword: "忘记密码",
      forgotPasswordTitle: "忘记密码",
      resetPasswordTitle: "重置密码",
      resetSuccessTitle: "重置成功",
      emailPlaceholder: "请输入您的邮箱地址",
      codePlaceholder: "验证码",
      sendCode: "发送验证码",
      resendCode: "重新发送",
      newPasswordPlaceholder: "新密码",
      confirmPasswordPlaceholder: "确认新密码",
      resetPasswordBtn: "重置密码",
      backToLogin: "返回登录",
      resetSuccessMessage: "密码重置成功！",
      resetSuccessTips: "请使用新密码登录。",
      emailRequired: "请输入您的邮箱地址",
      emailInvalid: "请输入有效的邮箱地址",
      codeRequired: "请输入验证码",
      newPasswordRequired: "请输入新密码",
      confirmPasswordRequired: "请确认新密码",
      passwordMismatch: "两次输入的密码不一致",
      sendCodeSuccess: "验证码发送成功",
      sendCodeFailed: "验证码发送失败",
      resetPasswordFailed: "密码重置失败",
      next: "下一步"
    },
    personalCenter: {
      title: "个人中心",
      profile: "个人资料",
      history: "历史记录",
      security: "账号安全",
      welcome: "欢迎来到金曼斯光电",
      brand: "JINMANS OPTOELECTRONICS",
      edit: "编辑",
      address: "地址",
      comingSoon: "敬请期待",
      template: "模板管理",
      templateSelector: "选择模板",
      templateName: "模板名称",
      templateAdd: "添加模板",
      templateEdit: "编辑",
      templateDelete: "删除",
      templateCompanyName: "公司名称",
      templateCompanyAddress: "公司地址",
      templateCompanyEmail: "公司邮箱",
      templateCompanyPhone: "公司电话",
      templateWebsite: "公司网站",
      templateLogo: "Logo",
      templateQrcode: "二维码",
      templateDefault: "默认",
      templateSetDefault: "设为默认",
      templateSetDefaultConfirm: "确认将此模板设为默认？只能有一个默认模板。",
      templateDeleteConfirm: "确认删除此模板？",
      templateCancel: "取消",
      templateSave: "保存",
      templateEmpty: "暂无模板",
      templateActions: "操作",
      favorites: "我的收藏",
      noFavorites: "暂无收藏",
      projects: "项目管理",
      noProjects: "暂无项目"
    },
    favorites: {
      toggleSuccess: "收藏成功",
      toggleCancel: "已取消收藏",
      localTip: "临时收藏成功，登录后可同步至账号",
      syncTitle: "同步本地收藏",
      syncMessage: "检测到本地临时收藏，是否同步至账号？",
      batchDelete: "批量删除",
      batchDeleteSuccess: "删除成功",
      toggleFail: "操作失败，请稍后重试",
          selectFirst: "请先勾选产品",
          quoteProductCount: "已选择",
          configRequired: "请先为以下产品选择配置参数：",
          configConfirm: "确认配置参数",
          configConfirmTitle: "以下配置将应用到各产品：",
          configConfirmTip: "提示：可以通过产品卡片上的下拉框调整每个参数。"
    },
    projects: {
      addToProject: "添加到项目",
      createProject: "新建项目",
      projectName: "项目名称",
      projectNamePlaceholder: "请输入项目名称",
      selectProject: "选择项目",
      noProjectYet: "暂无项目，请先创建",
      addSuccess: "成功添加到项目",
      addFail: "添加到项目失败",
      deleteProject: "删除项目",
      deleteProjectConfirm: "确认删除此项目？",
      deleteProjectSuccess: "项目已删除",
      removeProduct: "移除",
      removeProductSuccess: "产品已从项目中移除",
      duplicateSkipped: "个产品已在项目中，已跳过",
      emptyProject: "项目中暂无产品",
      backToProjects: "返回项目列表",
      generateQuote: "生成报价单",
      quoteSuccess: "报价单下载成功",
      quoteFail: "生成报价单失败"
    },
    tagsView: {
      refresh: '刷新',
      close: '关闭',
      closeOthers: '关闭其它',
      closeAll: '关闭所有'
    },
    settings: {
      title: '系统布局配置',
      theme: '主题色',
      tagsView: '开启 Tags-View',
      fixedHeader: '固定 Header',
      sidebarLogo: '侧边栏 Logo',
      language_0:'开孔尺寸',
      language_1:'功率',
      language_2:'所有产品',
      yes:"是",
      no:"否",
    },
    foot:{
      language_0:"©2025 深圳金曼斯光电科技有限公司版权所有",
      language_1:"电话",
      language_2:"传真",
      language_3:"室内产品目录",
      language_4:"非标准规格书",
      language_5:"户外产品目录",
      language_6:"ECO产品目录",
      language_7:"办公产品目录",
      language_8:"公司简介",
      language_9:"企业文化",
      language_10:"发展历程",
      language_11:"公司电话",
      language_12:"视频展示",
      language_13:"隐私政策",
      language_14:"条款与条件",
      language_15:"在线留言",
    },
    products:{
      language_0:"未找到匹配的产品."
    },
    search:{
      language_0: "搜索我们的产品",
      language_1: "搜索:产品代码/系列/类别/形状/类型/安装方式",
      language_2: "搜索",
      language_3: "清除",
      language_4: "搜索"
    },
    filter:{
      language_0:"筛选",
      language_1:"折叠",
      language_2:"展开",
      language_3:"重置",
    },
    productdetail:{
      language_0:"光束角",
      language_1:"系统输出",
      language_2:"开孔尺寸",
      language_3:"反光杯颜色",
      language_4:"请选择产品配置",
      language_5:"相关色温",
      language_6:"显色指数",
      language_7:"防护等级",
      language_8:"LED电压",
      language_9:"LED电流",
      language_10:"LED输出功率",
      language_11:"系统输出功率",
      language_12:"产品咨询",
      language_13:"生成PDF",
      language_14:"下载与资源",
      language_15:"规格书",
      language_16:"安装说明",
      language_17:"产品手册",
      language_18:"光度学(IES)",
      language_19:"概述",
      language_20:"安装方式",
      language_21:"固定方式",
      language_22:"安装说明",
      language_23:"开孔形状",
      language_24:"边框类型",
      language_25:"材质",
      language_26:"颜色",
      language_27:"尺寸",
      language_28:"开孔尺寸",
      language_29:"可调节性",
      language_30:"IP防护等级",
      language_31:"眩光值",
      language_32:"遮光角度",
      language_33:"电源",
      language_34:"等级",
      language_35:"调光类型",
      language_36:"输入电压",
      language_37:"输出电压",
      language_38:"输出电流",
      language_39:"驱动器认证",
      language_40:"光源",
      language_41:"光源",
      language_44:"色容差",
      language_45:"LED正向电压",
      language_46:"LED最大电流",
      language_47:"LED输出",
      language_48:"系统输出",
      language_49:"配件",
      language_50:"名称",
      language_51:"尺寸",
      language_52:"类型",
      language_53:"材质",
      language_54:"无可用数据",
    },
    message:{
        language_0:'视频专区',
        language_1:'产品',
        language_2:'项目',
        language_3:'下载',
        language_4:'定制',
        language_5:'新闻',
        language_6:'关于公司',
        language_7:'联系我们',
        language_8:'室内',
        language_9:'室外',
        language_10:'最新产品',
        language_11:"进一步了解最新产品",
        language_12:"金曼斯照明",
        language_13:"照明项目",
        language_14:"发现",
        language_15:"隐藏式项目",
        language_16:"灯架项目",
        language_17:"M6系列",
        language_18:"更多模型",
        language_19:"模块化设计",
        language_20:"多元模式",
        language_21:"目录",
        language_22:"关于金曼斯",
        language_23:"金曼斯灯饰有限公司(香港)公司自2009年成立于香港，工厂位于深圳，是一家高端商业照明制造商。2019年，我们搬到了新工厂。我们的设计和研发团队由经验丰富的专家和顾问组成。我们的研发团队聚集了一批年轻而富有经验的热情工程师。我们的照明灯具技术先进，设计美观，符合世界客户对照明应用的需求和设计师的品味。创国际商标，创百年企业。",
        language_24:"年",
        language_25:"行业经验",
        language_26:"团队",
        language_27:"证书",
        language_28:"区域",
        language_29:"员工",
        language_30:"新闻中心",
        language_31:"2024广州国际照明展览会",
        language_32:"阅读更多",
        language_33:"主页",
        language_34:"联系",
        language_35:"下载中心",
        language_36:"关于公司",
        language_37:"社区",
        language_38:"你可以下载金曼斯的画册和目录",
        language_39:"下载",
        language_40:"生态",
        language_41:"系列",
        language_42:"轨道",
        language_43:"走线灯",
        language_44:"专业定制照明解决方案，满足您的独特需求",
        language_45:"研发能力",
        language_46:"我们在研发方面做些什么",
        language_47:"研发投入",
        language_48: "金曼斯每年投入超过7%的营业额用于研发",  
        language_49: "ODM服务",
        language_50: "提供专业且高效的定制化支持" , 
        language_51: "新产品"  ,
        language_52: "每年开发超过20款新产品"  ,
        language_53: "专利"  ,
        language_54: "金曼斯拥有超过60项专利，保护我们的客户市场。"  ,
        language_55: "开发流程"  ,
        language_56: "专业定制化产品"  ,
        language_57: "工业设计"  ,
        language_58: "光学设计"  ,
        language_59: "结构设计"  ,
        language_60: "热设计"  ,
        language_61: "硬件和软件设计",  
        language_62: "专业测试"  ,
        language_63: "核心优势"  ,
        language_64: "创新和独特的工业设计"  ,
        language_65: "卓越的照明应用光学设计"  ,
        language_66: "出色的结构和热传导设计"  ,
        language_67: "世界上最时尚的设计"  ,
        language_68: "多项专利"  ,
        language_69: "30+项产品认证"  ,
        language_70: "优秀的质量保证"  ,
        language_71: "近30套专业设备"  ,
        language_72: "制造实力"  ,
        language_73: "高效生产基地"  ,
        language_74: "高质量供应链"  ,
        language_75: "高效生产基地",
        language_76: "质量控制"  ,
        language_77: "检验标准"  ,
        language_78: "严格的质量标准"  ,
        language_79: "误差值在0.5mm以内"  ,
        language_80: "底座平整度±0.3mm"  ,
        language_81: "粉末喷涂色差小于1.5"  ,
        language_82: "SDCM < 3, L80 (B10) @50,000小时"  ,
        language_83: "装配间隙小于0.3mm"  ,
        language_84: "无缝焊接"  ,
        language_85: "涂层外观零缺陷容忍度"  ,
        language_86: "包装符合ISTA 6A标准"  ,
        language_87: "全流程质量控制"  ,
        language_88: "来料质量检验IQC(≥97%)"  ,
        language_89: "生产过程检验IPQC(≥90%)"  ,
        language_90: "老化测试"  ,
        language_91: "包装前全面检验"  ,
        language_92: "成品检验FQC(100%)"  ,
        language_93: "仓库管理"  ,
        language_94: "出货检验OQC(100%)"  ,
        language_95: "安全配送"  ,
        language_96: "开始您的定制之旅"  ,
        language_97: "姓名"  ,
        language_98: "电子邮件"  ,
        language_99: "网站"  ,
        language_100: "您是否与金曼斯合作过"  ,
        language_101: "您在金曼斯的联系人是谁"  ,
        language_102: "是"  ,
        language_103: "否"  ,
        language_104: "定制规格"  ,
        language_105: "提供定制需求的详细描述，包括样式、尺寸、材料、功能等。" , 
        language_106: "我同意收集我的电子邮件以处理此请求" ,
        language_107: "提交",
        language_108:"随时了解金曼斯的最新消息和事件",
        language_109:"视频展示",
        language_110:"其他新闻",
        language_111: "始于2009年，照明行业领导者",
        language_112: "'打造国际品牌，铸就百年企业'",
        language_113: "公司文化的核心价值观",
        language_114: "让光创造价值，成为世界上最专业的空间照明灯具制造服务提供商。",
        language_115: "企业使命：聚焦光的力量，为世界创造最美的光。",
        language_116: "经营理念：客户至上，极致工艺，专业服务。",
        language_117: "服务理念：客户至上，行动迅速。",
        language_118: "光与金曼斯",
        language_119: "光为自然界万物提供能量。人造光也在建筑空间室内和景观等人为环境中通过增添美感和功能性来创造价值。创新是我们的追求。优质的光源是我们的坚持。但是，定义金曼斯的是对光的深深热爱和热情。",
        language_120: "国际先进设计",
        language_121: "这些属性描述了金曼斯推出的新系列，是金曼斯整个团队多年努力的成果。我们的设计师和工程师在外国顾问的支持下，通过采用新技术和新材料，同时坚持团结、务实、创新和奉献的核心价值观，创造了这些最先进的系列。",
        language_122: "我们的设计和研发团队由经验丰富的专家和顾问组成。我们的研发团队聚集了一群充满激情的工程师，他们既年轻又有经验。我们的照明灯具配备了先进的技术和美观的设计，满足了世界客户在照明应用中的需求和设计师的品味。",
        language_123: "实现绿色",
        language_124: "金曼斯致力于探索光与地球环境之间的关系，以通过高效利用能源、避免浪费，而非依赖根本上消极的节能方法，来创造一个丰富的下一代环境。金曼斯的产品系列以其卓越的品质和持久的性能为地球的可持续性做出了贡献。",
        language_125: "全过程质量控制",
        language_126: "过程",
        language_127: "我们是光工程师",
        language_128: "我们非常重视材料的来源，所有材料均在英国本地采购、加工和组装。我们完全控制供应链，因此我们可以制造由任何金属合金制成的任何部件，并且都是100%可回收的。",
        language_129: "模块化设计",
        language_130: "在LED灯具设计中采用模块化设计优化方法可以提高生产效率，降低成本并提高产品质量。通过模块化设计，LED灯具可以独立设计和优化光源、电源、连接和辅助功能，并享有提高生产效率、降低维护成本、方便产品升级和高质量可控性的优势。随着LED灯具市场的不断发展，模块化设计在LED灯具设计中将发挥越来越重要的作用。",
        language_131: "细致入微，追求每一个细节的完美",
        language_132: "我们在每个部件上提供的无与伦比的完美表面处理，要么为设计增添了奢华的额外层次，要么能够有机地将配件融入其自然栖息地，从而缩小了建筑照明和装饰照明之间的差距。",
        language_133: "可用表面处理 - 阳极氧化、电镀、粉末涂层、特殊喷漆",
        language_134: "可用原始金属表面处理 - 黄铜、铜、青铜、不锈钢、铝",
        language_135: "船用级可用 - 不锈钢（316L）、黄铜、铜、青铜",
        language_136: "平均每月推出1款新产品",
        language_137: "光创造了温馨的氛围，让生活更美好！经过多年的行业深耕，我们更好地理解了客户对美丽产品的期望。凭借高新技术，我们每月推出1款新模型。我们坚持产品的速度，开发更多高质量的创新产品。我们坚信质量是产品的灵魂，严格遵守产品选择、生产的每一个标准和每一个服务细节，为客户创造最大价值。",
        language_138: "我们的愿景",
        language_139:"电话",
        language_140:"上班时间",
        language_141:"地址",
        language_142:"广东省深圳市宝安区福海街道新田社区福瑞路139-1号2楼 ",
        language_143:"我们能帮什么忙",
        language_144:"名字",
        language_145:"姓",
        language_146:"咨询",
        language_147:"提交咨询",
        language_148:"中国广东 518105",
        language_149:"周一 至 周五",
        language_150:"代理/战略伙伴",
        language_151:"金曼斯与我们的代理商紧密合作，在全球服务内提供高品质的照明解决方案",
        language_152:"你可以在这里看到我们各种类型的视频",
        language_153:"首页",
        language_154:"金曼斯光电科技有限公司是一家致力于LED室内外照明产品的研发、生产及全球销售的创新企业。您可通过官网上的全系列产品展示、全球项目案例库及资质认证中心，深入了解我们的技术实力与行业积淀。",
        language_155:"您是否曾与金曼斯合作过？",
        language_156:"贵司在金曼斯的对接联系人是谁？",
        language_157:"定制规格",
        language_158:"请详细描述定制需求，包括款式、尺寸、材质、功能等",
        language_159:"申请已成功提交。请留意后续电话、短信或邮件通知！",
        language_160:"深圳金曼斯光电科技有限公司",
        language_161:"预览",
        language_162:"应用场景",
        language_163:"产品类别",
        language_164:"安装类型",
        language_165:"天花板安装",
        language_166:"地面灯",
        language_167:"壁灯",
        language_168:"嵌入式安装",
        language_169:"表面安装",
        language_170:"悬挂式安装",
        language_171:"轨道灯",
        language_172:"产品系列",
    },
    policy:{
      language_0:"隐私政策",
      language_1:"本隐私政策明确说明我们在您使用产品或服务期间如何处理您的个人信息，包括收集、使用、存储、共享、转移、公开披露及保护等环节。请在使用服务前仔细阅读并充分理解全部内容。如对本政策有任何疑问、意见或建议，欢迎通过文末提供的联系方式与我们联系。",
      language_2:"适用范围",
      language_3:"本隐私政策适用于您与本公司产品及服务的交互行为，包括但不限于通过官方网站、移动应用、客户端软件、微信公众号、小程序等平台使用服务。但不适用于以下情形：",
      language_4:"您应参考第三方通过我们的服务向您提供产品或服务时所采用的隐私政策。",
      language_5:"我们明确声明本隐私政策不适用于其他服务或产品。",
      language_6:"信息收集方式",
      language_7:"注册与登录信息",
      language_8:"当您注册或登录服务时，我们会收集您主动提供的信息，包括但不限于手机号码、电子邮箱、用户名及密码。此类信息用于账户创建与管理，保障服务安全便捷使用。例如在官网注册时，您需提供手机号码并设置符合安全标准的密码，随后通过短信验证码完成身份验证方可成功注册账户。",
      language_9:"使用过程中产生的信息",
      language_10:"设备信息",
      language_11:"您使用服务时，我们会收集设备相关数据，包括型号详情、操作系统版本、设备标识符（如IMEI、MEID、MAC地址）、屏幕分辨率、传感器配置、电池电量及网络类型。这些数据有助于我们提供定制化服务体验：根据屏幕尺寸自动调整页面布局，依据操作系统版本优化应用功能，确保服务在您的设备上稳定运行。",
      language_12:"日志信息",
      language_13:"在您使用服务期间，我们的服务器会自动记录各类日志详情，包括IP地址、访问时间、停留时长、浏览页面与内容、访问路径、搜索关键词、点击记录、上传/下载操作及错误日志。通过分析这些日志数据，我们能洞察您的使用习惯与需求，从而进行精准优化以提升服务性能和用户体验。例如，根据您的浏览路径和点击记录，我们可优化网站或应用页面结构，帮助您更高效地查找内容。",
      language_14:"位置信息",
      language_15:"若您明确授权我们获取位置数据，我们将通过GPS、基站、Wi-Fi等多种方式收集设备地理坐标，包括精确定位与大致定位信息。这有助于我们提供定制化服务，例如附近商家推荐、促销优惠及本地新闻更新。您可随时在设备设置或通过我们的服务界面关闭位置权限。关闭后我们将停止收集您的位置数据，但这可能影响部分基于位置的服务正常运行。",
      language_16:"其他方式收集的信息",
      language_17:"第三方平台授权",
      language_18:"当您选择通过第三方平台登录时，我们可能在您授权后获取该平台提供的部分信息，包括头像、昵称、性别、地区、用户ID及好友列表（仅在明确授权时获取）。收集这些信息旨在帮助您快速创建账户、简化登录流程并提供更个性化的服务。例如在使用服务时显示昵称和头像，可增强账户辨识度。",
      language_19:"问卷调查与反馈",
      language_20:"当您参与我们的调查、用户访谈，或通过客服渠道/反馈平台提供意见时，我们会收集您提供的信息，包括姓名、联系方式（若自愿提交）、产品/服务评价、建议、遇到的故障及相关描述。这些数据有助于我们理解您的需求与期望，从而针对性地改进产品/服务并提升服务质量。",
      language_21:"我们如何使用信息",
      language_22:"提供、维护和改进服务",
      language_23:"我们利用收集的信息来提供、维护并持续改进我们的产品与服务。具体而言，我们会使用您的注册信息创建和管理账户，确保顺畅登录及功能访问。通过分析设备数据和日志记录，我们提升服务兼容性与稳定性，同时解决潜在技术漏洞。此外，基于您的位置数据，我们提供符合您需求的本地化服务。",
      language_24:"个性化服务与推荐",
      language_25:"我们分析您的浏览历史、搜索记录及评价数据。结合算法模型进行分析后，为您提供个性化内容推荐与服务。包括但不限于：产品推荐、服务推荐、文章推荐、活动推荐及好友推荐。我们的目标是通过高效发现符合您需求的内容或服务，提升您的使用体验。",
      language_26:"自动化决策说明",
      language_27:"上述个性化推荐基于自动化决策机制。您有权拒绝自动化推荐服务，可通过客服渠道或服务设置页面申请关闭相关功能。",
      language_28:"客户服务与沟通",
      language_29:"我们将基于必要沟通需求使用您的信息，为您提供优质客服支持。当您联系客服团队进行咨询、反馈或售后请求时，我们会调用您的账户详情、交易记录及沟通存档，以精准把握需求并提供解决方案。此外，我们将通过短信、邮件或站内消息通知您服务更新，包括账户安全警报、订单状态更新及活动通知。您可根据偏好选择仅接收必要通知。",
      language_30:"安全保障",
      language_31:"为保障您的账户安全及服务整体安全性，我们运用收集的信息识别并防范各类安全风险。例如通过分析您的设备详情、登录IP地址、登录时间及位置信息，我们可检测异常登录行为。若发现陌生设备或可疑IP地址的未经授权访问，我们将立即发送安全警报，并采取登录限制或身份验证等措施保护您的账户安全。此外，我们利用这些信息防范欺诈、网络攻击、垃圾信息及其他安全问题。",
      language_32:"市场调研与产品开发",
      language_33:"我们将收集的用户数据进行匿名化及去敏感化处理，用于市场调研和产品开发。通过分析用户习惯与偏好，我们识别市场趋势以指导新产品开发和现有产品升级，从而持续提供更以用户为中心的产品与服务。例如，根据用户反馈及特定功能的使用频率，我们可能优化这些功能或开发相关扩展。",
      language_34:"法律合规与监管要求",
      language_35:"在法律、法规、规章、司法机关或行政机关强制性要求下，我们将依法使用您的信息以满足相关法规及监管要求。例如，我们可能根据司法调查令或行政执法通知书向相关部门提供案件相关必要信息。",
      language_36:"Cookie及类似技术的使用",
      language_37:"技术说明",
      language_38:"我们运用Cookie、像素标签及本地存储等技术存储用户偏好、优化服务体验并分析用户行为。Cookie是您访问服务时存储在设备上的小型数据文件。像素标签是嵌入网页或邮件的微型代码片段，用于追踪用户交互。本地存储则用于在设备上保存相关数据。",
      language_39:"管理模式",
      language_40:"您可通过浏览器禁用或删除Cookies及相关技术。具体操作请参阅浏览器帮助文档。但请注意，禁用相关技术可能导致部分服务及功能无法使用。",
      language_41:"信息存储",
      language_42:"存储期限",
      language_43:"我们将根据适用法律法规及实际服务需求确定您的个人信息保留期限。通常在您使用服务期间，我们将持续保存您的个人信息。当该信息不再用于提供服务且无法律保存要求时，我们将删除或匿名化您的个人数据。例如：账户注销后，除法律另有规定外，我们将在合理期限内清除您的账户信息及相关个人资料。",
      language_44:"存储地点",
      language_45:"您的个人信息将存储于中华人民共和国境内。若因业务需求需向境外传输个人信息，我们将依法获取您的明确同意，并采取相应安全措施确保您的个人信息获得与境内同等水平的保护。",
      language_46:"存储安全",
      language_47:"我们采用行业标准的安全存储技术和措施保护您的个人信息。通过加密、访问控制及数据备份协议，防止存储期间个人数据被窃取、篡改或泄露。我们定期对存储系统进行安全审计与维护，确保安全环境的完整性。",
      language_48:"信息共享方式",
      language_49:"与第三方服务商共享",
      language_50:"为提升服务质量，我们可能与严格筛选的第三方服务商（如云计算、物流机构）共享必要信息。此类信息仅限于服务交付目的。我们将与第三方签订协议，要求其按本政策及相关法规处理信息，禁止任何未经授权的使用。例如：为完成配送，我们向物流商提供订单配送详情；为保障交易顺利进行，我们向金融机构提供支付数据。",
      language_51:"基于法律要求的共享",
      language_52:" 在下列情形下，我们可能依据法律法规或司法行政机关的要求共享您的信息：",
      language_53:"保障国家安全、公共安全及社会公共利益；",
      language_54:"调查处理违法犯罪行为；",
      language_55:"响应司法机关签发的传票、搜查令等法律文书；",
      language_56:"遵守法律法规的强制性规定。",
      language_57:"经您明确同意的共享",
      language_58:"除上述情形外，在共享信息前，我们将明确告知您共享的目的、类型及接收方，仅在获得您明确同意后方可共享。您有权拒绝，但若拒绝，可能影响部分依赖该信息的服务使用。",
      language_59:"企业合并、分立、收购或破产清算期间的信息转移",
      language_60:"发生业务合并、分立、收购、资产转让或破产清算时，您的信息可能作为资产转移给接收方。我们将要求接收方继续遵守本政策，若其变更处理方式，您需重新同意。",
      language_61:"信息转移与公开披露",
      language_62:"信息转移",
      language_63:"未经您明确同意，我们不会将您的个人信息转移给任何第三方。但在合并、分立、收购、资产转让等法定情形下，我们将依据本政策第4条第5款规定，依法处理您的个人信息转移事宜。",
      language_64:"信息公开披露",
      language_65:"除非出现以下情形，否则我们不会公开披露您的个人信息：",
      language_66:"获得您的明确同意。",
      language_67:"根据法律法规规定或司法机关、行政机关的要求进行公开披露。",
      language_68:"为保护国家安全、公共安全、社会和公共利益，以及我们或其他用户的合法权益，必要时将进行公开披露。",
      language_69:"在公开披露您的个人信息时，我们将采取合理措施确保披露的合法性、正当性，并最大限度保障您的个人信息安全。",
      language_70:"您的权利",
      language_71:"访问权",
      language_72:"您有权随时访问您在本平台的个人信息。该信息包括但不限于您的基本账户信息（用户名、手机号码、电子邮箱等）、浏览记录、搜索记录、收藏记录、评价记录等。您可通过以下方式访问个人信息：",
      language_73:"登录我们的服务平台，进入'个人中心'或相关设置页面，按页面提示进行查询查看。",
      language_74:"联系客服人员提出访问请求。经身份验证后，我们将向您提供相关信息。",
      language_75:"更正权",
      language_76:"若您发现我们存储的个人信息存在错误、不完整或过时的情况，有权要求我们予以更正。您可通过以下方式行使更正权：",
      language_77:"在'个人中心'或相关设置页面，直接更正可修改的信息（如昵称、头像等）。",
      language_78:"对于无法自行修改的信息，您可联系客服人员并提供相关证明材料及正确信息。经核实后我们将及时为您更正并告知更正结果。",
      language_79:"删除权",
      language_80:"在下列符合法律法规的情形下，您有权要求我们删除您的个人信息：",
      language_81:"我们收集和使用您的个人信息违反法律法规或双方协议。",
      language_82:"我们不再向您提供服务且无法律法规要求继续保留您的个人信息。",
      language_83:"您已撤回对我们收集使用个人信息的同意。",
      language_84:"您通过法定途径要求我们删除个人信息。",
      language_85:" 您可通过联系客服人员行使删除权。经核实相关情况后，我们将依法及时处理您的删除请求。但需注意，若法律法规要求或为履行合同义务，我们可能需要保留部分信息，这可能导致无法完全删除所有数据。",
      language_86:"撤回同意权",
      language_87:" 您有权随时撤回先前同意我们收集和使用的个人信息。您可通过以下方式撤回同意：",
      language_88:"在我们服务平台的'设置'或相关设置页面，您可以修改每项信息收集和使用的授权状态。",
      language_89:"联系我们的客服人员，并明确告知您要撤回的同意事项。",
      language_90:"撤回同意后，我们将停止基于该同意收集和使用您的个人信息。但撤回前已依据您的同意所进行的处理行为的合法性及有效性不受影响。请注意，撤回同意可能导致部分服务功能无法使用，由此产生的后果由您自行承担。",
      language_91:"复制权",
      language_92:"您有权要求我们以可移植格式（如电子文档格式）提供您的个人信息，以便您将其转移至其他服务提供商。您可通过联系客服人员提交副本申请。经核实身份后，我们将在合理期限内向您提供相关信息的副本。",
      language_93:"注销权",
      language_94:"您有权注销在我们平台的账户。账户注销后，我们将依据适用法律法规处理您的个人信息。通常我们会删除您的账户详情及相关个人信息，或将其匿名化处理。您可通过设置页面完成注销流程，或联系客服办理。注销前我们将告知您可能产生的后果，包括但不限于：丧失账户权益、无法使用特定服务等。",
      language_95:"投诉权",
      language_96:"若您对隐私政策或个人信息处理方式存有疑问、疑虑，或认为相关操作侵犯了您的合法权益，有权向我们提出投诉。您可通过本政策末尾提供的联系方式与我们联络。我们将及时调查并处理投诉，在规定时限内反馈处理结果。若您对处理结果存有异议，亦可向相关监管机构举报。",
      language_97:"信息保护机制",
      language_98:"安全技术措施",
      language_99:" 我们采用多种先进的安全技术和措施保护您的个人信息，包括：",
      language_100:"数据加密技术：您的敏感信息（如密码、身份证号等）在存储和传输过程中均采用行业标准加密算法进行加密，防止信息被窃取、篡改或泄露。",
      language_101:"访问控制技术：建立严格的访问控制机制，对接触您个人信息的人员进行身份认证和权限管理，仅允许因工作需要知悉相关信息的授权人员访问，并对访问行为进行记录监控。",
      language_102:"安全防护技术：部署防火墙、入侵检测系统及防病毒软件等安全设备，定期开展安全扫描与漏洞检测，及时发现并防范网络攻击、恶意代码等安全威胁。",
      language_103:"数据备份与恢复技术：定期备份您的个人信息，建立完善的数据恢复机制，防范意外事件（如硬件故障、自然灾害等）导致的数据丢失，确保数据丢失时能及时恢复。",
      language_104:"安全管理体系",
      language_105:"我们建立了全面的安全管理体系以保护您的个人信息。关键措施包括：",
      language_106:"人员管理：对员工实施严格的背景审查及信息安全培训，确保其充分理解隐私保护政策、相关法律法规及安全规程。员工须签署保密协议，明确其对用户数据保密义务与责任。严禁擅自泄露、使用或篡改用户信息。",
      language_107:"流程管理：制定标准化个人信息处理流程，对信息收集、存储、使用、共享至销毁的各环节设置严格审批与操作规程，确保每项操作皆有章可循、可追溯。",
      language_108:"审计监督：定期对个人信息处理活动实施内部审计与监督，核查是否存在违反隐私政策及安全管理体系的行为，及时发现并纠正问题。",
      language_109:"安全事件响应：建立完善安全事件响应机制，明确报告、调查、处置及恢复流程。当发生个人信息泄露、数据丢失等安全事件时，将立即启动应急响应预案采取补救措施，最大限度降低影响。依据法律要求，及时向监管部门报告并通知受影响用户，向其提供事件基本情况、已采取措施及可执行的应对方案。",
      language_110:"未成年人保护",
      language_111:" 我们高度重视未成年人个人信息的保护。若您未满18周岁，在使用我们的服务前，应在法定监护人的指导下仔细阅读本隐私政策，并在获得法定监护人同意并陪同的情况下使用我们的服务及提交个人信息。",
      language_112:"我们不会主动收集未成年人的个人信息。若未成年人在未获得法定监护人同意的情况下向我们提供个人信息，其法定监护人可通过本政策末尾提供的联系方式联系我们，要求删除或更正相关信息。",
      language_113:"我们将采取更严格的措施保护所收集的未成年人个人信息，确保其安全。除非法律法规另有规定，在未获得法定监护人明确同意的情况下，我们不会向任何第三方共享未成年人的个人信息。",
      language_114:"隐私政策的变更",
      language_115:"我们可能根据法律法规更新、业务发展或服务调整修订本隐私政策。修订后的政策将在我们的服务平台（如官方网站）上发布，并通过适当方式通知您，包括平台首页弹窗通知、短信/邮件提醒或其他渠道。",
      language_116:"修订后的隐私政策自发布之日起生效。若您在修订后的隐私政策生效后继续使用我们的服务，即表示您同意受修订后的隐私政策约束。建议您定期查阅本隐私政策，了解最新的隐私保护规定。",
      language_117:"联系我们",
      language_118:"若您对本隐私政策有任何疑问、意见或建议，或需行使本政策赋予您的权利，请通过以下方式联系我们：",
      language_119:"客户服务",
      language_120:"电子邮箱",
      language_121:"联系地址：广东省深圳市宝安区福海街道新田社区福瑞路139-1号2楼",
      language_122:" 我们将在收到您的反馈后尽快处理并回复您的问题。通常情况下，我们将在15个工作日内给您明确答复。",
    },
    terms:{
          language_0:"服务条款",
          language_1:"条款协议",
          language_2:"本服务条款构成您（无论以个人身份或代表实体）与以'KAMS'为商业名称运营的Kam's Light Co., Limited（'KAMS'、'我们'、'我们的'）之间签订的具有法律约束力的协议。本协议规范您访问及使用网站的行为",
          language_3:"以及任何其他与上述网站相关联、链接或关联的媒体格式、媒体渠道、移动网站或移动应用程序（统称为'本网站'）。",
          language_4:"本公司于中华人民共和国注册成立，注册地址为中国广东省深圳市宝安区福海街道新田社区福瑞路139-1号2楼（邮编：518103）。访问本网站即表示您确认已阅读、理解并同意受本服务条款所有条款的约束",
          language_5:"若您不同意本条款的全部内容，则严禁使用本网站并须立即停止所有使用行为",
          language_6:"本网站不时发布的补充条款、条件或文件，特此通过引用明确纳入本服务条款。我们保留随时自行决定修订或修改本服务条款的权利。我们将通过更新本条款的'最后更新日期'通知您任何变更，您在此放弃接收每项变更单独通知的权利。建议您每次使用本网站时查阅适用条款，以确保知悉现行条款内容。修订后的服务条款发布后，您继续使用本网站即构成对修订条款的认可与接受",
          language_7:"本网站提供的信息不适用于任何其分发或使用将违反当地法律法规，或使我们承担该管辖区或国家注册义务的司法管辖区或国家内的个人或实体。因此，选择从其他地区访问本网站的个人应自行承担责任，并须在适用当地法律的范围内确保遵守相关法规。",
          language_8:"本网站未针对特定行业法规（如《健康保险携带与责任法案》（HIPAA）、《联邦信息安全管理法案》（FISMA）等）进行定制化设计。若您的使用行为受此类法律约束，则不得使用本网站。您不得以任何违反《格拉姆-里奇-比利雷法案》（GLBA）的方式使用本网站",
          language_9:"本网站仅面向年满18周岁的用户。未满18周岁者不得使用或注册本网站",
          language_10:"知识产权",
          language_11:"除非另有说明，本网站均为我方专有财产。本网站上的所有源代码、数据库、功能、软件、网站设计、音频、视频、文本、照片和图形（统称为'内容'），以及其中包含的商标、服务标记和徽标（统称为'标记'）均由我们拥有或控制，或已获得许可。这些内容受美国版权法、商标法、其他知识产权法、反不正当竞争法、国际版权法及国际公约的保护。",
          language_12:"本网站提供的内容及标识均按'原样'提供，仅供您获取信息及个人使用。除本服务条款明确规定外，未经我们事先明确书面同意，不得以任何商业目的复制、转载、汇编、再发布、上传、张贴、公开展示、编码、翻译、传输、分发、销售、授权或以其他方式利用本网站的任何部分、内容或标识。",
          language_13:"在您具备使用本网站资格的前提下，我们授予您有限许可，允许您访问和使用本网站，并下载或打印您合法获取访问权限的任何内容部分，但仅限于个人非商业用途。我们保留与本网站、内容及商标相关且未明确授予您的所有权利。若您从事涉及知识产权侵权的禁止行为（详见第4条'禁止活动'），我们有权终止您使用本网站的权利（依据第13条'期限与终止'），并就由此造成的损失向您追索法律救济。",
          language_14:"用户声明与保证",
          language_15:" 使用本网站即表明您声明并保证：",
          language_16:"您具备签订并遵守本服务条款的法律行为能力",
          language_17:"您在居住地司法管辖区内不属于未成年人",
          language_18:"您不得通过自动化或非人类方式访问本网站，包括但不限于使用机器人程序、脚本或其他手段",
          language_19:"您不得将本网站用于任何非法或未经授权的目的",
          language_20:" 您使用本网站的行为不得违反任何适用法律法规",
          language_21:"若您提供任何虚假、不准确、过时或不完整的信息，我们保留暂停或终止您的账户，并拒绝您当前或未来使用本网站（全部或部分）的权利",
          language_22:"禁止活动",
          language_23:" 您仅可为本网站提供的目的访问和使用本网站。除我们明确认可或批准的商业活动外，本网站不得用于任何商业用途",
          language_24:"作为本网站用户，您同意不",
          language_25:"未经我们事先书面许可，不得系统性地从本网站检索数据或其他内容，以直接或间接创建或汇编任何集合、汇编、数据库或目录",
          language_26:"欺骗、诈骗或误导我们或其他用户，尤其试图获取用户密码等敏感账户信息的行为",
          language_27:"规避、禁用或干扰本网站安全相关功能，包括防止或限制使用/复制任何内容的功能，或执行对本网站及/或其中内容使用限制的功能",
          language_28:"通过虚假陈述、恶意谣传或故意干扰我们的业务运营（由我们合理判断），诋毁、损害我们及/或本网站的声誉",
          language_29:" 利用从本网站获取的任何信息骚扰、虐待或伤害他人",
          language_30:"滥用我们的支持服务或提交虚假滥用或不当行为报告",
          language_31:"以违反任何适用法律法规的方式使用本网站",
          language_32:"未经授权对本网站进行框架嵌套或链接",
          language_33:"上传或传输（或试图上传或传输）病毒",
          language_34:"特洛伊木马程序",
          language_35:"或其他材料——包括过度使用大写字母及垃圾信息（持续发布重复文本）——干扰任何方对本网站的正常使用与体验，或修改、损害、破坏、改变或干扰本网站的使用、特性、功能、运行或维护",
          language_36:"从事任何自动化系统使用行为，包括但不限于使用脚本发送评论或消息、使用数据挖掘、机器人、蜘蛛程序、作弊工具、抓取工具或离线阅读器访问本网站，或开发、分发或启动任何未经授权的自动化系统或脚本（标准搜索引擎或互联网浏览器使用产生的情况除外）",
          language_37:"删除任何内容中的版权或其他专有权利声明",
          language_38:"试图冒充其他用户或个人，或使用其他用户的用户名",
          language_39:"上传或传输（或试图上传或传输）任何作为被动或主动信息收集/传输机制的材料，包括但不限于透明图标（'gifs'）、1×1像素图、网络跟踪器、Cookie或其他类似装置（有时称为'间谍软件'、'被动收集机制'）",
          language_40:"干扰、破坏或对本网站或与其相连的网络及服务施加不当负担",
          language_41:"骚扰、烦扰、恐吓或威胁任何参与为您提供本网站服务的员工或代理人",
          language_42:"试图规避本网站为防止或限制访问本网站或其任何部分而实施的任何措施",
          language_43:"未经我们事先书面同意，复制或改编构成或构成本网站部分的任何软件",
          language_44:"破译、反编译、反汇编或对构成本网站或其组成部分的任何软件进行逆向工程，除非适用法律明确允许",
          language_45:" 使用采购代理或采购代理商在本网站进行购买行为",
          language_46:"未经授权使用本网站，包括通过电子或其他手段收集用户名和/或电子邮箱地址以发送未经请求的邮件，或通过自动化手段或虚假身份创建用户账户",
          language_47:" 将本网站用于任何与我们竞争的行为，或利用本网站及/或内容从事任何营利活动或商业经营",
          language_48:"利用本网站宣传或销售商品或服务",
          language_49:"出售或转让您的个人资料",
          language_50:"用户生成内容",
          language_51:"本网站可能允许您参与聊天、撰写或参与博客、留言板、在线论坛及其他功能。本网站还可能为您提供向我们或在本网站上创建、提交、发布、展示、传输、表演、出版、分发或广播内容和材料的机会，包括但不限于文本、著作、视频、音频、照片、图形、评论、建议、个人信息或其他材料（统称为'投稿'）。贡献内容可能被本网站其他用户及第三方网站查看。因此，您传输的任何贡献内容均可能被视为非保密且非专有信息。",
          language_52:"当您创建或提供任何贡献内容时，您特此声明并保证：",
          language_53:" 您贡献内容的创作、分发、传输、公开展示或表演，以及对该等内容的访问、下载或复制，均不侵犯且不会侵犯任何第三方专有权利——包括但不限于著作权、专利权、商标权、商业秘密或人格权",
          language_54:" 您是该贡献内容的创作者和所有者，或已获得必要的许可、权利、同意、授权及许可，可使用并授权我们、本网站及其他用户以本网站及本服务条款所设想的任何方式使用您的贡献内容",
          language_55:"您已获得贡献内容中每位可识别个体的书面同意、授权及/或许可，允许使用该个体的姓名或肖像，以便本网站及本服务条款所设想的任何方式纳入并使用您的贡献内容",
          language_56:"您的贡献内容不存在虚假、不准确或误导性内容",
          language_57:"您的贡献内容不包含未经请求或未经授权的广告、宣传材料、传销活动、连锁信件、垃圾邮件、群发邮件或其他形式的招揽行为",
          language_58:"您的贡献内容不包含淫秽、猥亵、下流、污秽、暴力、骚扰、诽谤、中伤或其他令人反感的内容（由我们判定）",
          language_59:"您的贡献内容不得嘲弄、讥讽、贬低、恐吓或辱骂任何个人",
          language_60:"您的贡献内容不得用于骚扰或威胁（依据法律定义）任何其他人员，亦不得煽动针对特定个人或群体的暴力行为",
          language_61:"您的贡献内容不得违反任何适用法律、法规或规章",
          language_62:"您的贡献内容不得侵犯任何第三方的隐私权或公开权",
          language_63:"您的内容不得违反任何关于儿童色情的适用法律，亦不得意图损害未成年人的健康或福祉",
          language_64:"您的内容不得包含涉及种族、国籍、性别、性取向或身体残疾的冒犯性言论",
          language_65:"您的贡献内容不以其他方式违反本服务条款或任何适用法律法规的任何规定，亦不链接至违反上述规定的内容",
          language_66:"任何违反上述规定使用本网站的行为均构成对本服务条款的违约，我们可采取第13条（期限与终止）中规定的措施。",
          language_67:"内容贡献许可",
          language_68:" 您通过本网站任何部分发布贡献内容时，即自动授予我们且声明并保证您有权授予我们一项不受限制、无边界、不可撤销、永久性、非排他性、可转让、免版税、已全额支付的全球性权利与许可，允许我们为任何目的托管、使用、复制、再现、披露、销售、转售、出版、广播、 重新命名、归档、存储、缓存、公开表演、公开展示、格式转换、翻译、传输、摘录（全部或部分）及分发此类贡献内容（包括但不限于您的图像和声音）的权利与许可，用于任何目的——商业、广告或其他用途。本许可还包括创建衍生作品或将此类贡献内容整合至其他作品的权利，以及授予并授权前述权利的再许可。使用及分发可通过任何媒体格式及渠道进行",
          language_69:"本许可适用于任何现有或今后开发的任何形式、媒体或技术，包括我们对您姓名、公司名称和特许经营名称（如适用）的使用，以及您提供的任何商标、服务标记、商号、徽标以及个人和商业图像。您在此放弃对所提交内容享有的所有精神权利，并保证该内容未主张任何其他精神权利。",
          language_70:"我们不主张对您提交内容的所有权。您保留对所有提交内容及其相关知识产权或专有权利的完整所有权。对于您在本网站任何区域发布的提交内容所含的任何陈述或表述，我们概不承担责任。您对向本网站提交的内容承担全部责任，并明确同意就由此产生的任何及所有责任向我们提供赔偿，且承诺不会就您的内容对我们提起任何法律诉讼",
          language_71:" 我们保留以下权利，可自行决定：",
          language_72:"编辑、删减或修改任何投稿内容",
          language_73:"重新分类投稿内容，将其置于网站更合适的位置",
          language_74:"随时基于任何理由预先审查或删除投稿内容，无需另行通知。我们无义务监控您的贡献内容",
          language_75:"评论指南",
          language_76:"我们可能在网站上提供可发布评论或评分的区域。发布评论时，您必须遵守以下准则：您必须对被评论的个人/实体有亲身体验",
          language_77:"您的评论不得包含冒犯性粗俗语言、辱骂性言论、种族歧视言论、冒犯性言论或仇恨言论；",
          language_78:"您的评论不得包含基于宗教、种族、性别、国籍、年龄、婚姻状况、性取向或残疾的歧视性内容；",
          language_79:"您的评论不得涉及非法活动； 评论不得包含基于宗教、种族、性别、国籍、年龄、婚姻状况、性取向或残疾的歧视性内容",
          language_80:"评论不得涉及非法活动",
          language_81:"若您与被评对象存在竞争关系，不得发布误导性或不公正的负面评价",
          language_82:" 不得对行为合法性作出任何结论性判断",
          language_83:"您不得发布任何虚假或误导性陈述",
          language_84:"您不得组织活动鼓励他人发布评论，无论评论内容是正面还是负面",
          language_85:"我们有权自行决定接受、拒绝或删除评论。我们无义务审查或删除评论，即使任何方认为评论令人反感或不准确。评论不代表我们的立场，亦不必然反映我们或任何关联方、合作伙伴的观点。对于任何评论或由此产生的索赔、责任或损失，我们概不负责。发布评论即表示您授予我们永久性、非排他性、全球范围、免版税、已全额支付、可转让及可再许可的权利与授权，允许我们复制、修改、翻译、通过任何方式传输、展示、演示及/或分发与该评论相关的所有内容",
          language_86:"提交内容",
          language_87:" 您确认并同意，您向我们提供的任何关于本网站的问题、评论、建议、创意、反馈或其他信息（“提交内容”）均不具有保密性，并将成为我们的专有财产。我们拥有所有专有权利（包括所有知识产权），并有权为任何合法目的（商业或其他用途）不受限制地使用和传播此类提交内容，无需向您致谢或支付补偿。您特此放弃对任何此类提交内容的道德权利，并保证该等提交内容系您原创或您有权提交。您同意，对于您提交内容中任何专有权利的涉嫌或实际侵权或盗用行为，您不得向我们追索。",
          language_88:"第三方链接与内容",
          language_89:"本网站可能包含（或您可能通过本网站被引导至）指向其他网站的链接（”第三方网站“），以及属于或源自第三方的文章、照片、文本、图形、图片、设计、音乐、声音、视频、信息、应用程序、软件及其他内容或项目（‘第三方内容’）",
          language_90:" 我们不对第三方网站或第三方内容的准确性、适当性或完整性进行调查、监控或核实，且不对通过本网站访问的任何第三方网站或在本网站上发布、可通过本网站获取或从本网站安装的任何第三方内容承担责任——包括此类第三方网站或第三方内容所含的内容、准确性、冒犯性、观点、可靠性、隐私实践或其他政策。包含、链接至或允许使用/安装任何第三方网站或第三方内容的行为，均不构成我方对此类内容的认可或批准。",
          language_91:"若您选择离开本网站访问第三方网站，或使用或安装任何第三方内容，您需自行承担风险，且本服务条款将不再适用。您应仔细阅读从本网站导航至的任何网站或从本网站使用或安装的任何应用程序的适用条款和政策（包括隐私和数据收集实践）。您通过第三方网站进行的任何购买均应通过该等其他网站并与该等其他公司进行，我们对此类购买（仅限于您与相关第三方之间）不承担任何责任。您同意并确认我们不对第三方网站提供的产品或服务进行背书，且您应就因购买此类产品或服务所产生的任何损害，以及因任何第三方内容或与第三方网站互动而导致的任何损失或伤害，免除我们的责任。",
          language_92:"网站管理",
          language_93:" 我们保留权利（但无义务）：",
          language_94:"监控网站是否存在违反本服务条款的行为",
          language_95:"对任何经我们自行判断违反法律或本服务条款的人士采取适当法律行动——包括但不限于向执法机构举报该用户",
          language_96:"我们有权自行决定且不受限制地拒绝、限制访问、限制可用性或禁用（在技术可行的范围内）您的任何贡献内容或其任何部分",
          language_97:"我们有权自行决定且不受限制地移除或禁用所有过大或对系统造成负担的文件及内容，无需通知或承担责任",
          language_98: "以其他方式管理本网站，旨在保护我们的权利和财产，并确保网站正常运行",
          language_99:"隐私政策",
          language_100:"我们重视数据隐私与安全。请查阅我们的隐私政策",
          language_101:"使用本网站即表示您同意受我们的隐私政策约束，该政策通过引用纳入本服务条款",
          language_102:"请注意，本网站托管于中华人民共和国境内，我们严格遵循《中华人民共和国个人信息保护法》（PIPL）处理您的个人数据。若您所在地区关于个人数据收集、使用或披露的当地法律或要求与《个人信息保护法》存在差异，您继续使用本网站即构成您明确同意将个人数据传输至中国，并同意根据《个人信息保护法》在中国境内处理该数据。对于跨境数据传输，我们遵循《个人信息保护法》规定的跨境数据传输规则，包括完成相关备案手续（如需）",
          language_103:"版权侵权",
          language_104:"我们尊重他人的知识产权。若您认为本网站上或通过本网站提供的任何材料侵犯了您拥有或控制的版权，请立即通过以下联系方式向我们提交书面通知（以下简称“通知”）。您的通知副本将发送给发布或存储该材料的人员。请注意，根据适用法律，若通知中存在重大虚假陈述，您可能需承担损害赔偿责任。因此，若您无法确定本网站所载或链接的材料是否侵犯您的版权，建议您先咨询律师。",
          language_105:" 版权侵权通知联系方式如下：",
          language_106:"电子邮箱",
          language_107:"电话(",
          language_108:"服务时间：格林威治标准时间+8时区周一至周五9:00-18:00)",
          language_109:"条款与终止",
          language_110:" 本服务条款在您使用本网站期间始终完全有效",
          language_111:"在不限制本服务条款任何其他条款的前提下，我们保留自行决定且无需通知或承担责任的权利，可因任何原因或无理由拒绝任何人访问及使用本网站（包括封禁特定IP地址）——包括但不限于违反本服务条款所含任何陈述、保证或契约，或违反任何适用法律法规的行为。",
          language_112:" 我们可随时自行决定终止您对本网站的使用或参与，或删除您发布的任何内容或信息，无需事先警告",
          language_113:"若因任何原因终止或暂停您的账户，您不得以本人名义、虚假或借用名义、或任何第三方名义注册创建新账户——即使您系代表该第三方行事。除终止或暂停账户外，我们保留采取适当法律行动的权利，包括但不限于追究民事、刑事及禁令救济",
          language_114:"修改与中断",
          language_115:" 我们保留在不事先通知的情况下，自行决定：(1) 更改、修改、删除、修订、更新、暂停、终止或调整本网站内容或全部/部分功能； (2) 对本网站进行维护（可能因硬件、软件或其他技术问题导致中断、延迟或错误）",
          language_116:"我们无义务更新本网站任何信息，亦无义务维护、支持或提供本网站的修正、更新或版本发布。我们无法保证网站始终可用，且对于因以下原因导致的任何损失、损害或不便，我们不承担对您或任何第三方的责任：(a) 网站的任何修改、价格变更、暂停或终止； (b) 您在系统停机或技术故障期间无法访问或使用本网站",
          language_117:"适用法律",
          language_118:"本条款应受中华人民共和国法律管辖并依其解释。金光有限公司与您不可撤销地同意，因本条款引发的任何争议均应提交中华人民共和国法院专属管辖。",
          language_119:"争议解决",
          language_120:"16.1 非正式协商",
          language_121:"为加快争议解决并控制成本，对于您或我们（单称为“一方”，合称为“双方”）因本服务条款引起或与之相关的任何争议、纠纷或索赔（每项称为“争议”，合称为“争议”）， 双方同意在启动仲裁前，首先尝试通过非正式谈判解决争议（下文明确排除的争议除外），谈判期不少于三十（30）日。此类非正式谈判应自一方向另一方送达书面通知时启动。",
          language_122:"16.2 具有约束力的仲裁",
          language_123:" 因本合同引起或与本合同有关的任何争议，均应提交并最终由",
          language_124:"中国国际经济贸易仲裁委员会（CIETAC）",
          language_125:"根据其申请仲裁时有效的仲裁规则进行仲裁。仲裁员人数为三名。仲裁地为中华人民共和国深圳市。仲裁程序使用中文进行。合同适用中华人民共和国实体法。",
          language_126:"16.3 限制条款",
          language_127:"双方同意任何仲裁仅限于双方之间的争议。在法律允许的最大范围内，",
          language_128:"任何仲裁均不得与其他程序合并进行",
          language_129:"任何争议均不得以集体诉讼形式进行仲裁或采用集体诉讼程序",
          language_130:" 任何争议均不得以代表公众或其他任何人的名义提起诉讼",
          language_131:"16.4 非正式协商与仲裁的例外情形",
          language_132:"双方同意下列争议不适用前述关于非正式协商及具有约束力仲裁的规定",
          language_133:"任何旨在强制执行或保护一方知识产权权利、或涉及该权利有效性的争议",
          language_134:"任何与盗窃、盗版、侵犯隐私或未经授权使用指控相关或由此产生的争议",
          language_135:"任何要求禁令救济的诉求。若本条款被认定为非法或不可执行，则任何一方均不得选择就该条款中被认定为非法或不可执行部分所涉争议进行仲裁，此类争议应由上述管辖法院中具有管辖权的法院解决，双方同意接受该法院的属人管辖权",
          language_136:"修正条款",
          language_137:"本网站可能包含印刷错误、不准确信息或遗漏——包括描述、定价、可用性及其他细节。我们保留随时更正任何错误、不准确信息或遗漏，并更改或更新网站信息的权利，恕不另行通知。",
          language_138:"免责声明",
          language_139:"本网站按",
          language_140:"现状",
          language_141:"及",
          language_142:"可用性",
          language_143:"基础. 您同意使用本网站及相关服务需自行承担全部风险。在法律允许的最大范围内，我们对本网站及您的使用免除所有明示或暗示的担保——包括但不限于对以下内容的默示担保：   ",
          language_144:"内容与材料中的错误、疏漏或不准确之处",
          language_145:"因您访问和使用本网站而导致的任何性质的人身伤害或财产损失",
          language_146:"任何未经授权访问或使用我们的安全服务器及/或其中存储的任何个人信息和/或财务信息",
          language_147:"任何中断或停止向本网站传输或从本网站接收传输的行为",
          language_148:" 任何第三方可能通过本网站传输或传播的漏洞、病毒、特洛伊木马程序等恶意软件",
          language_149:"任何内容及材料中的错误或遗漏，或因使用本网站发布、传输或提供的任何内容而导致的任何形式的损失或损害",
          language_150:"我们不对通过本网站、任何超链接网站或任何横幅广告或其他广告中展示的网站或移动应用程序所宣传或提供的任何第三方产品或服务作出担保、认可、保证或承担责任。对于您与任何第三方产品或服务供应商之间的交易，我们既不参与其中，亦不承担任何监控责任。正如通过任何媒介或环境购买产品或服务时，您应在适当情况下行使最佳判断力并保持谨慎",
          language_151:"责任限制",
          language_152:"无论在任何情况下，我们及我们的董事、雇员或代理人均不对您或任何第三方承担任何直接、间接、后果性、惩戒性、附带性、特殊性或惩罚性损害赔偿责任——包括但不限于利润损失、收入损失、 数据丢失或其他损害——即使我们已被告知此类损害的可能性。尽管本条款可能存在相反规定， 我们对您因本服务条款或使用本网站而产生的任何索赔、损失或损害承担的全部责任，无论索赔的法律依据如何，均以5,000.00美元（或等值人民币，按中国外汇交易中心（CFETS）当日公布的美元兑人民币中间价计算）为限。",
          language_153:"赔偿",
          language_154:"您同意就任何第三方因下列事项提出或与之相关的任何损失、损害、责任、索赔或要求（包括合理的律师费和开支）对我们（包括我们的子公司、关联公司及各自的高管、代理人、合作伙伴和员工）进行抗辩、赔偿并使其免受损害：",
          language_155:"您的贡献内容",
          language_156:"您对本网站的使用",
          language_157:"您违反本服务条款的行为",
          language_158:" 违反本服务条款中所述的陈述与保证",
          language_159:"侵犯第三方权利——包括但不限于知识产权",
          language_160:" 您通过本网站联系的任何其他用户遭受的明显有害行为",
          language_161:"尽管有上述规定，我们保留以您承担费用的方式，对您需赔偿的事项进行独家辩护和控制的权利，您同意以您承担费用的方式配合我们对此类索赔的辩护。我们将在知悉任何此类索赔、诉讼或程序后，尽合理努力通知您该等须受本赔偿条款约束的事项",
          language_162:"用户数据",
          language_163:"我们将保留您传输至本网站的部分数据，用于管理网站性能，以及与您使用本网站相关的数据。尽管我们会定期执行常规数据备份，但您需对所有传输至本网站的数据或与您使用本网站开展的任何活动相关的数据承担全部责任。您同意我们对任何此类数据的丢失或损坏不承担责任，并在此放弃因数据丢失或损坏而对我们提起任何诉讼的权利",
          language_164:"电子通讯、交易与签名",
          language_165:"访问本网站、向我们发送电子邮件及填写在线表格均构成电子通讯。您同意接收电子通讯，并认可我们通过电子方式（电子邮件及本网站）向您提供的所有协议、通知、披露及其他通讯均满足书面形式的法定要求。",
          language_166:"加州用户与居民",
          language_167:"若您对我们的投诉未获满意解决，可通过书面形式联系加州消费者事务部消费者服务司投诉协助处，地址：1625 North Market Blvd., 套房N 112，萨克拉门托市，加利福尼亚州 95834；或致电 (800) 952-5210 或 (916) 445-1254。",
          language_168:"其他项",
          language_169:"本服务条款及我们通过网站发布或与网站相关的任何政策或操作规则，构成您与我们之间的完整协议与共识。我们未行使或未执行本服务条款的任何权利或规定，不构成对该权利或规定的放弃。本服务条款应在法律允许的最大范围内予以执行。我们可随时将全部或部分权利义务转让给他人。对于因超出我们合理控制范围的事件所导致的任何损失、损害、延误或未能采取行动，我们不承担任何责任。若本服务条款的任何条款或部分条款被认定为非法、无效或不可执行，该条款或部分条款应被视为可从本服务条款中分离，且不影响其余条款的有效性及可执行性。本服务条款或您使用本网站的行为，均不构成您与我方之间的合资、合伙、雇佣或代理关系。您同意本条款的起草方身份不得成为对我们不利的解释依据。您特此放弃基于本条款电子形式及双方未签署实体文件而可能主张的任何抗辩权。",
          language_170:"联系我们",
          language_171:"如需解决有关本网站的投诉或获取更多使用信息，请通过以下方式联系我们",
          language_172:"深圳金曼斯光电科技有限公司",
          language_173:"中国广东省深圳市宝安区福海街道新田社区福瑞路139-1号2楼 邮编：518103",
          language_174:"电话",
          language_175:"传真",
          language_176:"电子邮箱",
          language_177:"适销性、特定用途适用性",
          language_178:"不侵权",
          language_179:"我们不对本网站内容或任何链接网站内容的准确性或完整性作出任何保证或陈述，且不承担任何责任。",
          language_180:"尽管有上述规定，若责任限制违反《中华人民共和国民法典》规定，包括但不限于因我们的故意或重大过失所产生的责任，则责任限制不适用。",
          language_181:"美国某些州法律、中华人民共和国法律及其他国际法不允许对默示担保进行限制，或排除或限制某些损害赔偿。若此类法律适用于您，则上述部分或全部免责声明或限制条款对您不适用，您将享有该等法律规定的额外权利。",
          language_182:"您在此同意使用电子签名、合同、订单及其他记录，并同意通过本网站或由我们发起/完成的交易中，以电子方式接收通知、政策及交易记录。",
          language_183:"您特此放弃任何司法管辖区内要求使用原始签名、交付或保留非电子记录、或通过电子方式以外的任何手段进行支付或授予信贷的法规、条例、规则、法令或其他法律规定的权利或要求。",
    }, 
    enquiry:{
      language_0:"提交成功。我们将尽快安排专业人员与您联系！",
      language_1:"提交成功",
      language_2:"确认",
      language_3:"咨询此产品",
      language_4:"姓名",
      language_5:"电话/WhatsApp",
      language_6:"邮箱",
      language_7:"公司",
      language_8:"国家",
      language_9:"产品名称",
      language_10:"备注",
      language_11:"提交产品咨询",
      language_12:"请输入您的姓名。",
      language_13:"请输入您的公司名称。",
      language_14:"请输入您的电话/WhatsApp号码",
      language_15:"请输入您的电子邮箱",
      language_16:"请填写正确的电子邮箱",
      language_17:"请填写正确的电话号码",
      language_18:"正在提交...请稍候。",
    },
    pdf: {
      title: "非标准规格书",
      headerInfo: "头部信息",
      dataInfo: "数据信息",
      imageInfo: "图片信息",
      footerInfo: "底部信息",
      general: "基本信息",
      electrical: "电气信息",
      lightsource: "光源信息",
      logo: "Logo",
      project: "项目名称",
      type: "类型",
      productname: "产品名称",
      beamAngle: "光束角",
      location: "安装位置",
      fixation: "固定方式",
      installation: "安装方式",
      cutoutshape: "开孔形状",
      typeofbezels: "边框类型",
      shadingangle: "遮光角度",
      material: "材质",
      color: "颜色",
      size: "尺寸",
      cutoutsize: "开孔尺寸",
      adjustability: "可调节性",
      iprating: "IP防护等级",
      ugr: "<UGR",
      classes: "等级",
      dimmingtype: "调光类型",
      power: "功率 (W)",
      inputvolltage: "输入电压",
      outputvolltage: "输出电压 (V)",
      outputcurrent: "输出电流 (mA)",
      drivercertifications: "驱动器认证",
      lightsource_field: "光源",
      cri: "≤CRI",
      cct: "CCT (K)",
      sdcm: "<SDCM",
      letforwardvolltage: "LED正向电压 (V)",
      letmaximumcurrent: "LED最大电流 (mA)",
      letoutput: "LED输出 (lm)",
      image1: "产品示意图",
      image2: "尺寸图",
      image3: "配光曲线图",
      name: "姓名",
      address: "地址",
      web: "网站",
      email: "邮箱",
      phone: "电话",
      salesname: "销售姓名",
      date: "日期",
      qrcode: "二维码",
      createPDF: "生成PDF",
      reset: "重置",
      preview: "预览",
      pleaseWait: "正在生成规格书，请稍候",
      networkBusy: "网络繁忙，请稍后再试",
      // 验证消息
      beamAngle_required: "请输入光束角",
      productname_required: "请输入产品名称",
      location_required: "请输入安装位置",
      fixation_required: "请输入固定方式",
      installation_required: "请输入安装方式",
      cutoutshape_required: "请输入开孔形状",
      typeofbezels_required: "请输入边框类型",
      material_required: "请输入材质",
      color_required: "请输入颜色",
      size_required: "请输入尺寸",
      cutoutsize_required: "请输入开孔尺寸",
      adjustability_required: "请输入可调节性",
      iprating_required: "请输入IP防护等级",
      ugr_required: "请输入UGR",
      shadingangle_required: "请输入遮光角度",
      classes_required: "请输入等级",
      dimmingtype_required: "请输入调光类型",
      power_required: "请输入功率",
      inputvolltage_required: "请输入输入电压",
      outputvolltage_required: "请输入输出电压",
      outputcurrent_required: "请输入输出电流",
      drivercertifications_required: "请输入驱动器认证",
      lightsource_required: "请输入光源",
      cri_required: "请输入CRI",
      cct_required: "请输入CCT",
      sdcm_required: "请输入SDCM",
      letforwardvolltage_required: "请输入LED正向电压",
      letmaximumcurrent_required: "请输入LED最大电流",
      letoutput_required: "请输入LED输出",
      image1_required: "请输入产品示意图",
      image2_required: "请输入尺寸图",
      history:"历史记录",
      historyList:"历史记录列表",
      createTime:"创建时间",
      operation:"操作",
      reuse:"复用",
      close:"关闭",
      loadHistoryFailed:"加载历史记录失败",
      parameterDetailsPreview:"参数列表详情预览",
      parameterDetails:"参数详情",
      viewDetails:"查看详情",
      noParameters:"无参数",
      noParameterInfo:"无参数信息"
    }
}